import { NavLink, Outlet, Navigate } from "react-router-dom";
import { LayoutDashboard, Building2, FileText, KeyRound, LogOut, ExternalLink, Loader2, Inbox } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Brand } from "@/components/Brand";

const links = [
  ["/admin", "Dashboard", LayoutDashboard, "nav-dashboard", true],
  ["/admin/condomini", "Condomini", Building2, "nav-condomini"],
  ["/admin/modelli", "Modelli documenti", FileText, "nav-modelli"],
  ["/admin/richieste", "Richieste contatto", Inbox, "nav-richieste"],
  ["/admin/account", "Account", KeyRound, "nav-account"],
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  if (user === null) return <div className="grid min-h-screen place-items-center"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-slate-50 lg:grid lg:grid-cols-[248px_1fr]">
      <aside className="flex flex-col border-b border-slate-200 bg-white lg:sticky lg:top-0 lg:h-screen lg:border-b-0 lg:border-r">
        <div className="flex h-16 items-center px-5"><Brand /></div>
        <nav className="flex gap-1 overflow-x-auto px-3 pb-3 lg:flex-1 lg:flex-col lg:pb-0 lg:pt-4">
          {links.map(([to, label, Icon, tid, end]) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={tid}
              className={({ isActive }) => `flex shrink-0 items-center gap-2.5 rounded-md px-3 py-2 text-sm font-medium transition-colors ${isActive ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"}`}
            >
              <Icon className="h-4 w-4" /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden space-y-1 border-t border-slate-200 p-3 lg:block">
          <a href="/" target="_blank" rel="noreferrer" data-testid="nav-public-portal" className="flex items-center gap-2.5 rounded-md px-3 py-2 text-sm text-slate-600 hover:bg-slate-100"><ExternalLink className="h-4 w-4" /> Portale pubblico</a>
          <p className="truncate px-3 pt-2 text-xs text-slate-400" data-testid="admin-user-email">{user.email}</p>
          <button onClick={logout} data-testid="admin-logout-button" className="flex w-full items-center gap-2.5 rounded-md px-3 py-2 text-sm text-slate-600 hover:bg-red-50 hover:text-red-700"><LogOut className="h-4 w-4" /> Esci</button>
        </div>
      </aside>
      <main className="min-w-0 px-5 py-8 sm:px-10">
        <Outlet />
        <button onClick={logout} data-testid="admin-logout-button-mobile" className="mt-10 text-sm text-slate-500 lg:hidden">Esci</button>
      </main>
    </div>
  );
}
